
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";

export default class ServiceView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._extraBoxEl;

        this._itemEls = {};
    }

    getItems(){
        let html = "";
        let newobj = {}; 
        // 去重
        this._model._items = this._model._items.reduce((preVal, curVal) => {
            newobj[curVal._id] ? '' : newobj[curVal._id] = preVal.push(curVal); 
            return preVal 
        }, [])
            this._model._items.forEach((item) => {
                html += `<div class="clearfix right_item" csid='${item._id}'>
                    <div class="fl e_goods">
                    <span class="fl e_goods_desc" >
                        <a style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" target="_blank" href="${item._link}">${item._name}</a>
                        <span class="le_tip_btn_solid" style="display:${this.getInvalidInfo(item).msg ? 'block' : 'none'}">${this.getInvalidInfo(item).msg}</span>
                    </span>
                    </div>
                    <div class="fl le_width_172 e_price" sid='${item._id}'>
                        <p style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="le_paddingl_65" gid='${item._id}'> ¥${item._price}</p>
                    </div>
                    <div style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="fl le_width_172 e_quantity">${item._count}</div>
                    <div class="fl le_width_172 e_sum">
                        <p style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="le_paddingl_65">¥${item.getTotalPrice()}</p>
                    </div>
                    <div class="fl le_width_116 e_action">
                    <p class="le_paddingl_26" style="display:${ !this._model._parent._invalid ?'inline-block':'none'};" tag='removeService' sid='${item._id}'>删除</p></div>
                </div>`;
                this._itemEls[item._id] = null;
            });
            
        return html;
    }

    render(){
        let html = "";
        if(this._model._items && this._model._items.length > 0) {
            html += `<div class="clearfix extra_item service ">
                <div class="fl e_name extra_item_left">服务</div>
                <div class="fl extra_item_middle">${this.getItems()}</div>
            </div>`;
            $(this._parentEl).html($(html));
            this._el = this._model._parent._view._extraBoxEl.find('div.service');
            
            for(let i in this._itemEls){
                this._itemEls[i] = this._el.find("div[csid="+i+"]");
            }
            this.regEvent();
        }

    }

    regEvent(){
        let that = this;
        this._el.off("click","p[tag='removeService']").on("click","p[tag='removeService']",function(){
            let sid = $(this).attr("sid");
            var _this = $(this);
            var codes ="";
            that._el.find('.right_item').each(function(index,item){
                if($(item).children().siblings('.e_action').children('p').attr('sid') == sid) {

                } else {
                    codes += $(item).children().siblings('.e_action').children('p').attr('sid') + '@';
                }
            }); 
            codes = codes.substr(0,codes.length-1);
            that._model.removeServices(sid).then(x=>{
                // 在这里调这个接口是因为删除服务之后, 弹框里的服务列表数据并没有更新 , 还会带有原先的数据和样式
                that._model._parent.modifyItemFromCart({opsType:3,content:codes}).then(x=>{
                    if(!codes) {
                        // console.log('当前没有选择服务商品',$(that._model._parent._view._el).find('p.service_box button span').html());
                        // console.log('当前没有选择服务商品',that._model);

                        // $(that._el).hide();
                        $(that._model._parent._view._serverBoxEl).siblings('.le_color_red').find('span').html('选择服务');
                    }
                });
            }).catch(err=>{
                Alert.showTip(err);
            })
        })
    }
}